import React, { Fragment, useEffect, useState } from "react";
import Breadcrumbs from "common-ui/lib/common/CommonElements/Breadcrumbs";
import { Nav, Tab, Card } from "react-bootstrap";
import { CardBody, Container } from "reactstrap";
import LandingPage from "../LandingPage";
import { useSelector } from "react-redux";

const ApplicationSettings = () => {
    const [activeKey, setActiveKey] = useState(1);
    const userObject = useSelector(state => state?.user?.userRoles);
    const app = useSelector(state => state?.user?.appName);

    return (
        <Fragment>
            <Container fluid>
                <Breadcrumbs mainTitle={'General'} />

                <Card>
                    <CardBody>
                        <Tab.Container activeKey={activeKey} defaultActiveKey={'1'} onSelect={(key) => setActiveKey(key)} >
                            <Nav variant="underlines">
                                <Nav.Item className="mr-5px">
                                    <Nav.Link eventKey={'1'} className={activeKey == 1 ? 'application-active' : ''}>Landing Page</Nav.Link>
                                </Nav.Item>
                            </Nav>
                            <Tab.Content>
                                <Tab.Pane eventKey={'1'}>
                                    <LandingPage />
                                </Tab.Pane>
                            </Tab.Content>
                        </Tab.Container>
                    </CardBody>

                </Card>
            </Container>


        </Fragment>
    )
}

export default ApplicationSettings;